import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getBookedGraphData } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

const useGetBookedGraphData = (options?: UseQueryOptions) =>
  useQuery<any>({
    queryKey: [userQueryKeys.bookedGraph],
    queryFn: () => getBookedGraphData().then((res) => res.data),
    staleTime: 300000,
    ...options,
  });

export default useGetBookedGraphData;
